import * as ACTIONS from '../actions';
import { LanguageCode } from '../core/types/ILanguage';

export default (language: LanguageCode) => ({
  type: ACTIONS.CHANGE_LANGUAGE,
  language,
});
